import createListSlice from './createListSlice';

export default createListSlice;
